import styled from 'styled-components'
import { cores } from '../../styles'
import { TextBig, TextMd, TextSm } from '../../styles/text'

export const OffCanvasWhole = styled.div`
  border-radius: 8px 0 0 0;
`

export const OffCanvasHeader = styled.div`
  background-color: ${cores.corSecundaria};
  border-radius: 8px 0 0 0;
`

export const OffCanvasBody = styled.div`
  background-color: ${cores.corPrincipal};
`

export const LinksList = styled.ul`
  margin-top: 20px;

  li {
    margin-bottom: 20px;
  }
`

export const NestedLinksList = styled.ul`
  margin-left: 8px;
`

export const MenuLink = styled(TextBig)`
  &:hover {
    color: ${cores.corSecundaria};
  }
`

export const ComingSoonBig = styled(TextBig)`
  margin-bottom: 0px;
  color: #949494ff;
  cursor: not-allowed;
`

export const ComingSoonSm = styled(TextSm)`
  margin: 0px;
  color: ${cores.corSecundaria};
`
